import React from 'react';

const RadioField = ({ label, name, options, register, rules, error, onChange, explanation, valueField, textField, index }) => {
  return (
    <div className="mb-3 flex flex-col w-full">
      <label className='text-brandDarkBlue text-sm font-bold pr-6 mb-4'>{label} {rules && <span className='text-red'>*</span>}</label>
      <div className="multi-select-radio">
        {options.map((option, optionIndex) => (
          <div className="flex items-start mb-2" key={`${option.value}-${optionIndex}`}>
            <input
              type="radio"
              id={`${name}-${index}-${option.value}`}
              name={name}
              value={option.value}
              {...register(name, rules)}
              onChange={onChange}
              className="w-auto mt-1 mr-2"
              data-code-name={option.codeName}
            />
            <div className='flex flex-col'>
              <label className='text-sm pr-6 mb-1' htmlFor={`${name}-${index}-${option.value}`}>
                {option.label}
              </label>
              {option.explanation && (
                <span className="text-brandDarkBlue text-xs text-gray-500 my-1">{option.explanation}</span>
              )}
            </div>
          </div>
        ))}
      </div>
      {error && <span className='text-red text-xs'>{error}</span>}
    </div>
  );
};

export default RadioField;